<template>
  <v-row class="mb-15 fill-height">
    <v-col>
      <v-row>
        <v-col>
          <h1>
            Reporte de Seguro de Gastos Medicos Mayores
          </h1>
        </v-col>
      </v-row>
      <v-row class="mb-15" style="padding: 30px">
        <v-col cols="12" lg="3">
          <h3>Selecciona el rango de fechas</h3>
          <v-date-picker style="width: 100%" v-model="dates" range></v-date-picker>
          <v-btn rounded color="primary" style="width: 100%" dark @click="generateReport">Generar Reporte</v-btn>
          <v-btn rounded color="primary" style="width: 100%; margin-top: 20px" :disabled="!report.length > 0">
            <download-csv :data="reportDownload" name="reporteSGMM.csv">
              Descargar Información
            </download-csv>
          </v-btn>


        </v-col>
        <v-col cols="12" lg="9">
          <div>
            <div v-if="loading" style="text-align: center">
              <h2 clas="pb-4">Cargando Reporte....</h2>
              <br /><br />
              <md-progress-spinner :md-diameter="100" :md-stroke="10" md-mode="indeterminate"></md-progress-spinner>
            </div>
          </div>

          <v-data-table v-if="!loading && reportType == 'lead'" :headers="columns" :items="report" item-key="name"
            class="elevation-1" :search="search" :custom-filter="filterOnlyCapsText" :loading="loading"
            loading-text="Cargando...">
            <template v-slot:top>
              <v-text-field v-model="search" label="Buscar" class="mx-4"></v-text-field>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
var moment = require('moment-timezone');

export default {
  data() {
    return {
      roles: JSON.parse(localStorage.getItem('roles')),
      uuid: localStorage.getItem('agenteUuid'),
      dates: [],
      downloadText: 'Descargar Reporte En Excel',
      downloading: false,
      loading: false,
      reportType: 'lead',
      report: [],
      reportDownload: [],
      search: '',
      columns: [
        {
          text: 'Uuid',
          align: 'start',
          sortable: false,
          value: 'uuid',
        },
        { text: 'Medio', value: 'Medio' },
        { text: 'Canal', value: 'Canal' },
        { text: 'Nombre', value: 'Nombre' },
        { text: 'Apellidos', value: 'Apellidos' },
        { text: 'Telefono', value: 'Telefono' },
        { text: 'Correo', value: 'Correo' },
        { text: 'Pregunta 1', value: 'Pregunta 1' },
        { text: 'Edad', value: 'Edad' },
        { text: 'Fecha Lead', value: 'Fecha' },
      ],
    };
  },

  methods: {
    convertDate(date) {
      const dateRes = moment(date);
      dateRes.tz('UTC', true);
      return dateRes.tz('America/Mexico_City').format('DD-MM-YYYY HH:mm');
    },
    getColor(calories) {
      if (calories > 400) return 'red';
      else if (calories > 200) return 'orange';
      else return 'green';
    },
    generateReport() {
      let vm = this;
      vm.report = []
      vm.reportType = 'lead';
      let config = {
        headers: {
          Authorization: 'Bearer ' + localStorage.agenteAccessToken,
        },
      };
      let inicioUTC = null
      let finUTC = null

      if (this.dates.length > 0) {
        if (this.dates[1]) {
          inicioUTC = moment.utc(this.dates[0]).format('YYYY-MM-DD HH:mm:ss')
          finUTC = moment.utc(this.dates[1]).add(24, 'hours').subtract(1, 'seconds').format('YYYY-MM-DD HH:mm:ss')
        } else {
          inicioUTC = moment.utc(this.dates[0]).format('YYYY-MM-DD HH:mm:ss')
          finUTC = moment.utc(this.dates[0]).add(24, 'hours').subtract(1, 'seconds').format('YYYY-MM-DD HH:mm:ss')
        }
        //restar 6 horas al reques
        //moment.utc(element.fecha).subtract(6, 'hours').format('DD/MM/YYYY HH:mm:ss'),
      }

      let fechas = {
        fechaInicio: inicioUTC,
        fechaFin: finUTC,
      };

      vm.loading = true;
      this.$axios
        .post('/v1/reportes/leadsGGMSegurify', fechas, config)
        .then((response) => {
          response.data.map((element) => {
            vm.report.push({
              'uuid': element.uuid,
              'Medio': element.medio,
              'Canal': element.canal,
              'Nombre': element.nombre,
              'Apellidos': element.apellidos,
              'Telefono': element.telefono,
              'Correo': element.correo,
              'Pregunta 1': element.pregunta_1,
              'Edad': element.edad,
              'Fecha': moment.utc(element.fecha).subtract(6, 'hours').format('DD/MM/YYYY HH:mm:ss'),
            });
          })
          response.data.map((element) => {
            vm.reportDownload.push({
              'uuid': element.uuid,
              'Medio': element.medio,
              'Canal': element.canal,
              'Nombre': element.nombre,
              'Apellidos': element.apellidos,
              'Telefono': element.telefono,
              'Correo': element.correo,
              'Pregunta 1': element.pregunta_1,
              'Edad': element.edad,
              'Fecha': moment.utc(element.fecha).subtract(6, 'hours').format('DD/MM/YYYY HH:mm:ss'),
            });
          })

          vm.loading = false;
        });
    },

    // Table
    filterOnlyCapsText(value, search) {
      return (
        value != null &&
        search != null &&
        typeof value === 'string' &&
        value.toString().indexOf(search) !== -1
      );
    },
  },
};
</script>
